module.exports = __webpack_public_path__ + "img/dpr-invite.055ef947.png";